import { AppearanceSectionConnected } from '@/features/settings/connected'

export default function SettingsAppearancePage() {
  return <AppearanceSectionConnected />
}
